exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2oCXsbvXIYFdYAH7myzRu6{font-size:12px;font-weight:400;height:24px;color:\"[theme:themeDarkAlt, default:#005A9E]\"}html[dir] ._2oCXsbvXIYFdYAH7myzRu6{border-radius:4px;padding:0}._2oCXsbvXIYFdYAH7myzRu6:active,._2oCXsbvXIYFdYAH7myzRu6:hover{color:\"[theme:themeDarkAlt, default:#005A9E]\"}.CjcQuBw6N4wbAMw8zXZEV{font-size:12px;font-weight:400}html[dir] .CjcQuBw6N4wbAMw8zXZEV{margin:1px 0 0 0}", ""]);
// Exports
exports.locals = {
	"viewEmailButton": "_2oCXsbvXIYFdYAH7myzRu6",
	"emailIcon": "CjcQuBw6N4wbAMw8zXZEV"
};